const $ = require('jquery');
import EditChecker from '../../components/EditChecker/EditChecker';
import SubmitModalFlow from '../../components/SubmitModalFlow/SubmitModalFlow';
import {SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT} from "../../constants";
import run from '../../utilities/run';



// Live form from jsp
run("#create-bundle-form, #bundle-detail", ()=>{const el = $("#create-bundle-form");
  attachWizard(el);
  setupEditChecker();
});


function setupEditChecker(){
  EditChecker.bindNavigation();
  EditChecker.bindChangeListener("#create-bundle-form");
  EditChecker.bindCancelButton(".bundle-cancel-btn");
}

function attachWizard(el){
  const typeAheadItems = el.data("type-ahead-items");
  const submitBundleURL = el.data("submit-bundle-url");
  const submitModalTitleTxt = el.data("submit-modal-title-txt");
  const submitModalBodyTxt = el.data("submit-modal-body-txt");
  const submitModalBtnTxt = el.data("submit-modal-btn-txt");
  const editModalTitleTxt = el.data("edit-modal-title-txt");
  const editModalBodyTxt = el.data("edit-modal-body-txt");
  const skuCheckUrl = el.data("validate-sku-url");
  const duplicateSkuMessage = el.data("duplicate-sku-error-message");
  const portletNamespace = el.data("namespace");
  const items = el.data("items");
  const form = el;
  isDup();
  isEdit();
  shouldEnableSubmit();
  
  function isDup() {
    const dupFlag = el.data("isdup");
    if (dupFlag) {
      const catId = el.data("product-cat-id");
      el.find("#bundle-category").val(catId).trigger("change");
    }
  }

  function isEdit()
  {
    
    const kitItems = el.data("kit-items");
    if(kitItems)
    {
      for (let i=0;i<kitItems.length;i++) {
        addProducts(kitItems[i].kitChildItmSku,kitItems[i].prdName,kitItems[i].kitId,kitItems[i].kitChildItmQty);
      }
      const existingItemId = el.data("existing-item-id");
  
      const productId = el.data("product-id");

      const catId = el.data("product-cat-id");
      
      if(existingItemId)
      {
        el.find("#bundle-category").val(catId).trigger("change");
        el.find("#budnle-itmId").val(existingItemId);
        el.find("#budnle-prdId").val(productId);

      }
    }
  }

  form.on("blur",".bundle-sku-name",validateDuplicateBundle);
  form.on("change","#bundle-category",shouldEnableSubmit);

  function validateDuplicateBundle() {
    const skuVal = el.find(".bundle-sku-name").val();
    $.ajax({
        async: false,
        data: {
          ['sku']:skuVal
        },
        url: skuCheckUrl,
        dataType:"JSON",
        type: 'POST',
        success: function(data){
          if(data == true) {
            el.find('.dup-sku').hide();  
          }else{
            el.find('.dup-sku').show();
          }  
        }  
     });
  }

  function removeRow(){
    $($(this).closest("tr")).remove();
    shouldEnableSubmit();
    shouldEnableMessageOnPage();
  }

  const select2AjaxDefaults = {
      dataType: 'json',
      delay: 250,
      processResults: function (data, params) {
      params.page = params.page || 1;
      return {
        results: data.items,
        pagination: {
          more: (params.page * 20) < data.total_count
        }
        };
      },
      cache: true
      };


  const typeAhead = $('.product-name-typeahead');
    typeAhead.select2({
      placeholder: "Type product name (SKU)",
      allowClear: true,
      ajax: {
        ...select2AjaxDefaults,
        url: el.data("get-product-names-and-items-url"),
        cache: false,
        data: configureDataCallback(
          {
            paramKey: 'likeSku'
          }
        )
      },
      minimumInputLength: 3
    });

    typeAhead.on("select2:select", function(e) {
        const res = e.params.data.text.split("--");
      addProducts(res[0],res[1],null,null);
      typeAhead.typeahead('val', '');
      shouldEnableSubmit();
      typeAhead.val(null).trigger('change');
    });

    function configureDataCallback({paramKey}){
      return function(params){
        return {
          [paramKey] : params.term        
        };
      };
    }


  /*typeAhead.typeahead(null, {
    name: 'typeAheadItemsJSON',
    limit: 5,
    source: substringMatcher(typeAheadItems)
  }).on('typeahead:selected', function() {
    const str = this.value;
    const res = str.split("--");
    addProducts(res[0],res[1],null,null);
    typeAhead.typeahead('val', '');
    shouldEnableSubmit();
  });*/

  function shouldEnableMessageOnPage()
  {
    const numberOfQauntity = 	$(".bundle-quantity").length;
    if(numberOfQauntity == 0)
    {
      $("#selected-prd-table").hide();
      $("#no-prd-selected-text").show();
    }
  }


  function shouldEnableSubmit()
  {

    const skuValid = !form.find('.dup-sku').is(':visible');
    if(skuValid == false){
      $(".bundle-submit-btn").addClass("disabled");
      $(".edit-bundle").addClass("disabled");
      return false;
    }

    const bundleCat = $("#bundle-category").val();
    if(!bundleCat){
      $(".bundle-submit-btn").addClass("disabled");
      $(".edit-bundle").addClass("disabled");
      return false;
    }

    const numberOfQauntity = 	$(".bundle-quantity").length;
    if(numberOfQauntity == 0)
    {
      $(".bundle-submit-btn").addClass("disabled");
      $(".edit-bundle").addClass("disabled");
      return false;
    }
    else if(numberOfQauntity == 1){
      const valueOfQauntity = $(".bundle-quantity").val();
      if(valueOfQauntity != "" && valueOfQauntity != "1")
      {
        $(".bundle-submit-btn").removeClass("disabled");
        $(".edit-bundle").removeClass("disabled");
        return true;
      }
      else
      {
        $(".bundle-submit-btn").addClass("disabled");
        $(".edit-bundle").addClass("disabled");
        return false;

      }
    }
    else if(numberOfQauntity > 1)
    {
      $(".bundle-submit-btn").removeClass("disabled");
      $(".edit-bundle").removeClass("disabled");
      return true;
    }
  }

  $('#budnle-listOfProducts').dataTable({
    select: {
      style:    'os',
      selector: 'td:first-child'
    },
    data: items,
    "bPaginate": false,
    "order": [[ 1, "asc" ]],
    columns: [
    { data:   "itmId", "orderable": false,
    render: function ( data, type, row ) {
      if ( type === 'display' ) {
        const html = '<div class="checkbox checkbox-success cb-large">' +
        '<input type="checkbox" id="itmId-' + row.itmId + '" value="option1" checked="" name="prod2" />' +
        '<label for="itmId-' + row.itmId + '"></label>' +
        '</div>';
        return html;
      }
      return data;
    },
    className: "select-checkbox", width: "45px"},
    { data: "itmSku", "class":"details-control" , width: "126px"},
    { data: "prdName", "class":"details-control"}
    ]

  });

  function setQuantityVal(kitChildItmQty)
  {
    if(kitChildItmQty != null)
    {
      return kitChildItmQty;
    }
    else{
      return "1";
    }
  }

  function addProducts(itemSku,prdName,kitId,kitChildItmQty) {
    $("#selected-prd-table").show();
    $("#no-prd-selected-text").hide();
    let highestId = parseInt($("#bundle-prd-table tbody tr:last").attr("id"));
    if(isNaN(highestId)){
      highestId = 0;
    }else{
      ++highestId;
    }

    $("#bundle-prd-table").find('tbody')
    .append($('<tr id=' + highestId + ' class="product-item">')
      .append($('<td class="vert-middle">')
        .append($('<input type="number">')
          .attr('id', portletNamespace+'quantity_row_'+highestId)
          .attr('name', portletNamespace+'quantity'+'_row_'+highestId)
          .attr('min', '1')
          .attr('class', 'form-control required q-input text-center products-tab-quantity-input bundle-quantity')
          .attr('placeholder', "Quantity")
          .attr('value', setQuantityVal(kitChildItmQty))
          .on("change", shouldEnableSubmit)
          )
        .append($('<input type="hidden">')
          .attr('name', portletNamespace+'prodTabSku')
          .attr('value', itemSku+"_row_"+highestId)
          )
        .append($('<input type="hidden">')
          .attr('name', portletNamespace+'kitId'+'_row_'+highestId)
          .attr('value', kitId))
        )
      .append($('<td class="vert-middle">')
        .append($('<span class="text-purple products-tab-product-name">')
          .attr('id', itemSku+'_row_'+highestId)
          .text(itemSku)
          )
        .append($('<input type="hidden">')
          .attr('name', portletNamespace+'itemSku'+'_row_'+highestId)
          .attr('value', itemSku)
          )
        )
      .append($('<td class="vert-middle">')
        .append($('<span class="products-tab-product-description">')
          .attr('name', portletNamespace+'prodDescription')
          .attr('id', portletNamespace+'prodDescription_row_'+highestId)
          .text(prdName)
          )
        .append($('<input type="hidden">')
          .attr('name', portletNamespace+'prodTabProdDescription'+'_row_'+highestId)
          .attr('value', prdName)
          )
        )
      .append($('<td class="text-center vert-middle">')
        .append($('<span>')
          .attr('id', 'delete_row'+highestId)
          .attr('class', 'icon-remove')
          .attr('style', 'cursor: pointer;')
          .on('click', removeRow)
          )
        )
      );
    $( "#"+portletNamespace+"products-list" ).val("");

  }

  function substringMatcher(strs) {
    return function findMatches(q, cb) {
      let matches, substringRegex;
// an array that will be populated with substring matches
matches = [];

// regex used to determine if a string contains the substring `q`
substringRegex = new RegExp(q, 'i');

// iterate through the pool of strings and for any string that
// contains the substring `q`, add it to the `matches` array
$.each(strs, function(i, str) {
  if (substringRegex.test(str)) {
    matches.push(str);
  }
});
cb(matches);
};
}

$('#bundle-addProductsLink').click(function() {
  $("#bundle-listOfProductsModal").modal("show");
});

$('#checkall').click(function() {
  if ($(this).is(':checked')) {
    $('#bundle-listOfProductsModal div input').prop('checked', true);
  } else {
    $('#bundle-listOfProductsModal div input').prop('checked', false);
  }
});

$('#bundle-addProductsLink').click(function() {
  $('#bundle-listOfProductsModal div input').prop('checked', false);
  $('#bundle-listOfProductsModal #checkall').prop('checked',false);
  $('#bundle-numberSelected').html("<p><b>0 Products Selected</b></p>" );
});

$('#budnle-listOfProducts').mousemove(function() {
  const selectCount = document.querySelectorAll('#bundle-listOfProductsModal input[type="checkbox"]:checked').length-$('#checkall:checked').length;
  $('#bundle-numberSelected').html("<p><b>" + selectCount + " Products Selected</b></p>" );
});

$('#bundle-add-product-select-btn').click(function(){

  const skus = $('#bundle-listOfProductsModal table tr td :checkbox:checked').map(function () {
    return $(this).closest('tr').find("td").eq(2).text();}).get();

  const productNames = $('#bundle-listOfProductsModal table tr td :checkbox:checked').map(function () {
    return $(this).closest('tr').find("td").eq(1).text();}).get();

  for (let i=0;i<skus.length;i++) {
    addProducts(productNames[i],skus[i],null,null);
  }

  shouldEnableSubmit();
});

$('.edit-bundle').click(function(e) {
  e.preventDefault();
  submitBundle(editModalTitleTxt, editModalBodyTxt);
});

$(document).on("click", ".bundle-submit-btn", function(e){
  e.preventDefault();
  submitBundle(submitModalTitleTxt, submitModalBodyTxt);
});

function submitBundle(title, body) {
  if(!shouldEnableSubmit() || !form.valid())
  {
    return false;
  }
  const submitModalFlow = new SubmitModalFlow({
    confirmModalTitle: title,
    confirmModalBody: `<div class="q-pad-all-xl">${body}</div>`,
    confirmModalBtnText: submitModalBtnTxt,
    onConfirmClick: function() {
      submitModalFlow.showLoadingModal();
      saveNow();

      function saveNow(){
        $.ajax({
          data: $('#create-bundle-form').serialize(),
          url: submitBundleURL,
          dataType:"JSON",
          type: 'POST',
          success: submitBundleSucess,
          error: submitBundleError
        });
      }

      function submitBundleSucess(){
        EditChecker.setPageClean();
        submitModalFlow.showSuccessModal();
        setTimeout(function() {
          location.href = $('#create-bundle-form').data('view-product-lookup-page-url');
        }, SUCCESS_MODAL_TIMEOUT_WITH_REDIRECT);
      }

      function submitBundleError(){
        submitModalFlow.hideAllModals();
      }
    }
  });
  submitModalFlow.init();
  submitModalFlow.showConfirmModal();
}


}




// WEBPACK FOOTER //
// ./src/pages/products/productBundle.js